// extracted by mini-css-extract-plugin
export default {"form__detail--main":"form_form__detail--main__186H9","form__detail__details":"form_form__detail__details__yot7B","form__icon-container":"form_form__icon-container__TaV7c"};